module.exports = __webpack_public_path__ + "img/programme6.b7bc41dd.png";